<script lang="ts">
  export let col = 12;
  export let colMd: number | null = null;
  export let offset = 0;
  export let offsetMd = 0;
  export let alignSelf = "initial";
  export let alignSelfMd: boolean | null = null;
</script>

<div
  class={`${$$restProps.class || ""} grid-item col-${col} col-md-${
    colMd ? colMd : col
  } offset-${offset} offset-md-${
    offsetMd || offsetMd == 0 ? offsetMd : offset
  } align-${alignSelf} align-md-${alignSelfMd ? alignSelfMd : alignSelf}`}
>
  <slot />
</div>

<style lang="scss">
  $aligns: stretch, end, flex-end, initial;

  @each $align in $aligns {
    .align-#{$align} {
      align-self: $align;
    }
  }

  @each $align in $aligns {
    .align-md-#{$align} {
      @include breakpoint("small") {
        align-self: $align;
      }
    }
  }
</style>
